import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { Role } from '@core/configs/roles.config';
import { AuthService } from '@core/services/apis';

@Component({
  selector: 'pivot-sidebar-menu',
  styleUrls: ['./sidebar-menu.component.scss'],
  templateUrl: './sidebar-menu.component.html',
})
export class SidebarMenuComponent implements OnInit {
  readonly role = Role;
  collapse = false;
  isHovered = true;
  isClicked = true;
  isLogin = false;
  @Output() toogleSidenav = new EventEmitter<void>();
  menuItems: any[] = [
    {
      icon: 'corporate-management',
      link: 'corporate-management',
      title: '法人管理',
      role: Role.roleCCJAdmin,
    },
    {
      icon: 'account-management',
      link: 'account-management',
      title: 'アカウント管理',
      role: Role.roleCCJAdmin,
    },
    {
      icon: 'help',
      link: 'help',
      title: '案内管理',
      role: Role.roleCCJAdmin,
    },
    {
      icon: 'repair',
      link: 'login-notice',
      title: 'ログイン画面のお知らせ',
      role: Role.rolePublic,
    }
  ];

  constructor(
    private authService: AuthService,
  ) {
    // constructor
  }

  ngOnInit() {
    if (this.authService.loggedIn()) {
      this.isLogin = true;
    }
  }

  toggleMenu() {
    this.collapse = !this.collapse;
    this.isClicked = !this.isClicked;
    this.toogleSidenav.emit();
  }
}
